import { render } from "./TranslatableContent.vue?vue&type=template&id=b514634a&ts=true"
import script from "./TranslatableContent.vue?vue&type=script&lang=ts"
export * from "./TranslatableContent.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__